export default "__VITE_PUBLIC_ASSET__b7523dc3__"